export type ImpactInfluenceGroup = {
  id: string;
  heading: string;
  iconSrc: string;
  iconAlt: string;
  items: string[];
};

export const impactInfluenceContent = {
  pretitle: 'Impact and Influence',
  heading: 'Powering transformation at scale',
  intro:
    'Udacity’s Societal Impact programs are designed to support governments, institutions, and foundations in achieving large-scale digital transformation and nationwide development goals. Our global programs improve the livelihoods of diverse populations and workforces through radical, large-scale talent transformation journeys around the skills of the future.',
  imageSrc: '/images/government/impact-influence/student.jpg',
  imageAlt: '',
  eyebrowIconSrc: '/images/government/impact-influence/eyebrow-broadcast.svg',
};

export const impactInfluenceGroups: ImpactInfluenceGroup[] = [
  {
    id: 'governments-nations',
    heading: 'Governments & Nations',
    iconSrc: '/images/government/impact-influence/icon-globe.svg',
    iconAlt: '',
    items: [
      'Nationwide digital literacy',
      'Globally relevant workforce upskilling',
      'Bridged digital and labor market gaps',
      'Ambition and digital transformation',
    ],
  },
  {
    id: 'foundations-enterprises',
    heading: 'Foundations & Enterprises',
    iconSrc: '/images/government/impact-influence/icon-buildings.svg',
    iconAlt: '',
    items: ['Corporate social responsibility', 'Philanthropy', 'Diversity and inclusion'],
  },
];
